import { useRegistrationInstance } from "@/api/registrations";
import { config } from "@/utils/config";

export const useRegistrationStatus = () => {
  const { data } = useRegistrationInstance();

  const isOpen = !!data?.registrations;
  const pepeEnabled = config.extensions?.pepe?.enabled === true;

  return {
    /** Registrations are open, either through Pepe or traditional account creation. */
    isOpen,
    /** Whether Pepe is open. */
    pepeOpen: isOpen, // backward compatibility
    /** Whether Pepe is enabled. */
    pepeEnabled,
  };
};
